import optimizationsApi from 'api/optimizations';
import { buildOptimizationsV2AllRulesMock } from 'mocks/optimizations_v2_all_rules';

const readBooleanEnv = (value) => {
  if (value == null) return false;
  const v = String(value).trim().toLowerCase();
  return v === '1' || v === 'true' || v === 'yes' || v === 'on';
};

const ENV_USE_MOCK_OPTIMIZATIONS_V2 = readBooleanEnv(
  process.env.REACT_APP_USE_MOCK_OPTIMIZATIONS_V2
);

const ENV_USE_MOCK_OPTIMIZATIONS_V2_ALL_RULES = readBooleanEnv(
  process.env.REACT_APP_USE_MOCK_OPTIMIZATIONS_V2_ALL_RULES
);

const LS_ALL_RULES_KEY = 'useMockOptimizationsV2AllRules';
const LS_PREVIEW_KEY = 'useMockOptimizationsV2';

const readLocalStorageFlag = (key) => {
  if (typeof window === 'undefined') return false;
  try {
    return readBooleanEnv(window.localStorage.getItem(key));
  } catch (_e) {
    return false;
  }
};

export const OPTIMIZATIONS_V2_SOURCES = Object.freeze({
  ALL_RULES_MOCK: 'all_rules_mock',
  PREVIEW: 'preview',
  API: 'api',
});

export function getOptimizationsV2Source() {
  if (ENV_USE_MOCK_OPTIMIZATIONS_V2_ALL_RULES || readLocalStorageFlag(LS_ALL_RULES_KEY)) {
    return OPTIMIZATIONS_V2_SOURCES.ALL_RULES_MOCK;
  }
  if (ENV_USE_MOCK_OPTIMIZATIONS_V2 || readLocalStorageFlag(LS_PREVIEW_KEY)) {
    return OPTIMIZATIONS_V2_SOURCES.PREVIEW;
  }
  return OPTIMIZATIONS_V2_SOURCES.API;
}

export function setOptimizationsV2MockOverride(source) {
  if (typeof window === 'undefined') return;
  try {
    const ls = window.localStorage;
    if (source === OPTIMIZATIONS_V2_SOURCES.ALL_RULES_MOCK) {
      ls.setItem(LS_ALL_RULES_KEY, 'true');
      ls.removeItem(LS_PREVIEW_KEY);
    } else if (source === OPTIMIZATIONS_V2_SOURCES.PREVIEW) {
      ls.setItem(LS_PREVIEW_KEY, 'true');
      ls.removeItem(LS_ALL_RULES_KEY);
    } else {
      ls.removeItem(LS_ALL_RULES_KEY);
      ls.removeItem(LS_PREVIEW_KEY);
    }
  } catch (_e) {
    /* ignore */
  }
}

const isObject = (v) => typeof v === 'object' && v !== null;

export function assertOptimizationsResponse(payload) {
  if (!isObject(payload)) throw new Error('OptimizationsResponse: payload no es un objeto');
  const { active, expired } = payload;
  if (!isObject(active) || !isObject(expired)) {
    throw new Error("OptimizationsResponse: faltan 'active'/'expired'");
  }
  if (!Array.isArray(active.groups) || !Array.isArray(expired.groups)) {
    throw new Error("OptimizationsResponse: 'groups' debe ser array");
  }
}

export async function getOptimizationsV2() {
  const source = getOptimizationsV2Source();
  if (source === OPTIMIZATIONS_V2_SOURCES.ALL_RULES_MOCK) {
    const payload = buildOptimizationsV2AllRulesMock();
    assertOptimizationsResponse(payload);
    return payload;
  }
  if (source === OPTIMIZATIONS_V2_SOURCES.PREVIEW) {
    // Preview/sample cards served by the backend (same shape as get-optimizations).
    const response = await optimizationsApi.getOptimizationsPreview();
    assertOptimizationsResponse(response?.data);
    return response.data;
  }

  const response = await optimizationsApi.getOptimizations();
  assertOptimizationsResponse(response?.data);
  return response.data;
}
